var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataContext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1135 13.6668V9.00016H2.66683C2.48273 9.00016 2.3335 9.1494 2.3335 9.3335V13.3335C2.3335 13.5176 2.48273 13.6668 2.66683 13.6668H6.1135ZM6.1135 13.6668L6.11351 2.66683C6.11351 2.48273 6.26274 2.3335 6.44684 2.3335H9.56017C9.74427 2.3335 9.89351 2.48273 9.89351 2.66683V13.6668M6.1135 13.6668H9.89351M9.89351 13.6668H13.3402C13.5243 13.6668 13.6735 13.5176 13.6735 13.3335V6.00016C13.6735 5.81607 13.5243 5.66683 13.3402 5.66683H9.89352L9.89351 13.6668Z",
    stroke: "#8F97A5",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataContext);
export default __webpack_public_path__ + "static/media/data-context.1488465b.svg";
export { ForwardRef as ReactComponent };